import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { EmeraldChatAlternativeBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function EmeraldChatAlternative() {
  return (
    <>
      <SEO
        title="Best Emerald Chat Alternative - Talkvee (100% Free & Stable)"
        description="Looking for a free Emerald Chat alternative? Talkvee is a 100% free video chat platform. No Emerald Gold subscriptions, no constant crashes, just authentic connections."
        pathname="/emerald-chat-alternative"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Emerald Chat Alternative", "item": "https://talkvee.com/emerald-chat-alternative" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <EmeraldChatAlternativeBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">The 100% Free Emerald Chat Alternative</h1>
          <p className="landing-subtitle">
            Tired of paywalls, expensive premium subscriptions, and constant website crashes? Talkvee connects you with real people globally for free. Enjoy a lightning-fast connection with built-in games and zero hidden fees.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Talkvee vs. Emerald Chat</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#fee2e2', padding: '20px', borderRadius: '12px', border: '1px solid #fecaca'}}>
              <h4 style={{margin: '0 0 10px', color: '#b91c1c', fontSize: '1.1rem'}}>❌ Emerald Chat</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#7f1d1d', lineHeight: '1.6'}}>
                <li>Expensive Subscriptions</li>
                <li>Frequent Site Crashes</li>
                <li>Bots & Poor Moderation</li>
              </ul>
            </div>
            <div style={{background: '#dcfce7', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#15803d', fontSize: '1.1rem'}}>✅ Talkvee</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                <li>100% Free Forever</li>
                <li>Stable, Modern PWA</li>
                <li>Strict Human Moderation</li>
              </ul>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Is Talkvee really a free Emerald Chat alternative?",
              a: "Yes! While Emerald Chat limits basic features behind their paid Emerald Gold and Platinum tiers, Talkvee is completely free with zero paywalls."
            },
            {
              q: "Does Talkvee crash as much as Emerald Chat?",
              a: "No. Talkvee is built on modern, lightweight architecture to ensure a lightning-fast, stable connection without the freezing issues common on older platforms."
            },
            {
              q: "Do I need an account to join?",
              a: "No! You can skip the sign-up process and use our quick guest login to start chatting immediately."
            }
          ]}
        />
      </div>
    </>
  );
}